import { TokenSession, TokenClient, MissingAuthCookieError } from 'urbnTokenLib';
import { scopeTypes } from '../constants';
import {
    LoginUtility,
    ProfileClient
} from '../loginUtility/loginUtility';

import { error as errorLogger, debug } from './logger';

export function getLoggedInState() {
    try {
        const tokenSession = TokenSession.fromCookie();

        if (tokenSession.hasScope(scopeTypes.AUTHORIZED) || tokenSession.hasScope(scopeTypes.REGISTERED)) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        if (error instanceof MissingAuthCookieError) {
            debug('Missing auth cookie in getLoggedInState, returning false');
        } else {
            errorLogger(`Error getting logged in state: ${JSON.stringify(error)}`);
        }
        return false;
    }
}

function setupLoginUtility(state) {
    const siteId = state.core.constants.siteId;
    const tokenURL = state.core.constants.urls.token;
    const profileURL = state.core.constants.urls.profile;

    const tokenClient = new TokenClient(siteId, tokenURL);
    const profileClient = new ProfileClient(siteId, profileURL);
    const loginUtility = new LoginUtility(tokenClient, profileClient);

    return loginUtility;
}

export function signInUser(state, emailAddress, password) {
    const loginUtility = setupLoginUtility(state);

    return loginUtility.signIn(emailAddress, password);
}

export function resetPassword(state, emailAddress) {
    const loginUtility = setupLoginUtility(state);

    return loginUtility.forgotPassword(emailAddress);
}

export function getTokenTracerValue() {
    try {
        const tokenSession = TokenSession.fromCookie();

        if (tokenSession.tracer) {
            return tokenSession.tracer;
        }
    } catch (err) {
        if (err instanceof MissingAuthCookieError) {
            debug('Missing auth cookie in getTokenTracerValue, returning false');
        } else {
            errorLogger(`Error getting token tracer value: ${JSON.stringify(err)}`);
        }
        return false;
    }
}
